import SectionLabel from '../../../../../components/SectionLabel';
import { Grid, DropdownItemProps, Popup, Icon } from 'semantic-ui-react';
import { Field } from 'formik';
import { FormikErrorMessage } from '../../../../../components/ErrorMessage';
import React, { ReactElement, useState, useEffect, SyntheticEvent } from 'react';
import { getErrorFormik } from '../../../../../services/errors';
import { StepProps } from '../../../BondInsuranceForm';
import { FieldLabel } from '../../../../../styles';
import Dropdown from '../../../../../components/Dropdown';
import { PurposesEnum } from '../../../../../enums/purposes.enum';
import { PersonTypesEnum } from '../../../../../enums/person-types.enum';
import {
  naturalCommercialReasonOptions,
  naturalResidentialReasonOptions,
  legalCommercialResidentialReasonOptions,
  validityOptions
} from '../../../types';
import CustomDatePicker from '../../../../../components/CustomDatePicker';
import AppMaskedInput from '../../../../../components/MaskedInput';
import { iRootDispatch, iRootState } from '../../../../../store';
import { BondInsuranceFormState } from '../../../../../store/types/temp-types';
import { connect } from 'react-redux';
import { DATE_INPUT_MASK } from '../../../../../services/masks';
import styled from 'styled-components';
import { SpacedColumn } from '../../../style';

const SpanWrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px
  font-weight: bold;
`;

const IconWrapper = styled(Icon)`
  color: #ffffff;
  background-color: ${props => props.theme.main.color} !important;
`;

const SECTION_NAME = 'property_info';

const mapState = (state: iRootState) => ({});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateBondInsurance: (bondInsuranceFormState: Partial<BondInsuranceFormState>) =>
    dispatch.bondInsuranceForm.updateBondInsurance(bondInsuranceFormState)
});

type ContractDataProps = StepProps &
  ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;

const ContractData = (props: ContractDataProps): ReactElement => {
  const {
    errors,
    touched,
    handleInputChange,
    handleDateChange,
    values,
    setFieldTouched,
    setFieldValue,
    updateBondInsurance
  } = props;

  const [locationInProgress, setLocationInProgress] = useState<boolean>(false);

  const { property_info, initial_info } = values;

  const [reasonsOptions, setReasonsOptions] = useState<Array<DropdownItemProps>>([]);

  useEffect(() => {
    if (
      initial_info.purpose === PurposesEnum.commercial &&
      initial_info.tenant_type === PersonTypesEnum.natural
    ) {
      setReasonsOptions(naturalCommercialReasonOptions);
      setFieldValue(`${SECTION_NAME}.reason`, 'Sede de empresa');
    } else if (
      initial_info.purpose === PurposesEnum.residential &&
      initial_info.tenant_type === PersonTypesEnum.natural
    ) {
      setReasonsOptions(naturalResidentialReasonOptions);
      setFieldValue(`${SECTION_NAME}.reason`, 'Imóvel próximo de familiares');
    } else {
      setReasonsOptions(legalCommercialResidentialReasonOptions);
    }
  }, []);

  const validateErros = (field: string) =>
    getErrorFormik(errors, touched, SECTION_NAME, field);

  return (
    <>
      <SectionLabel text="DADOS DO CONTRATO" />
      <Grid.Row>
        <SpacedColumn mobile={16} tablet={8} computer={8}>
          <FieldLabel>MOTIVO DA LOCAÇÃO* </FieldLabel>
          <Field
            id={`${SECTION_NAME}.reason`}
            name={`${SECTION_NAME}.reason`}
            onChange={handleInputChange}
            onClose={() => setFieldTouched(`${SECTION_NAME}.reason`, true)}
            error={validateErros('reason')}
            options={reasonsOptions}
            component={Dropdown}
            placeholder="Selecionar..."
            fluid
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.reason`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={8} computer={8}>
          <FieldLabel>
            <SpanWrapper>
              VIGÊNCIA DO SEGURO FIANÇA*
              <Popup
                trigger={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <IconWrapper
                      circular
                      size={'small'}
                      name={'help'}
                      style={{ cursor: 'pointer', marginLeft: '6px', fontSize: 8 }}
                    />
                  </div>
                }
                content={
                  'Essa vigência se refere a validade em meses do seu seguro fiança! Então, se colocar 12 meses, precisará renovar o seu seguro daqui a 12 meses!'
                }
                position={'top center'}
              />
            </SpanWrapper>
          </FieldLabel>
          <Field
            id={`${SECTION_NAME}.validity`}
            name={`${SECTION_NAME}.validity`}
            completeValue={true}
            options={validityOptions}
            onChange={(e: SyntheticEvent, data: any) => {
              setFieldValue(`${SECTION_NAME}.validity`, data.value);
            }}
            className={validateErros('validity')}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.validity`, true)}
            component={Dropdown}
            selection
            compact
            basic
            fluid
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.validity`} />
        </SpacedColumn>
      </Grid.Row>
    </>
  );
};

export default connect(mapState, mapDispatch)(ContractData);
